import React from 'react';
import { Box, BoxProps, useMantineColorScheme } from '@mantine/core';

interface BaseContainerProps extends BoxProps {
    children: React.ReactNode;
}

export const getBaseGlassStyles = (colorScheme: string) => ({
    backgroundColor: colorScheme === 'dark' ? 'var(--modal-bg)' : "#fff",
    border: colorScheme === 'dark' ? '1px solid var(--modal-border)' : '1px solid #eee',
    borderRadius: 'var(--mantine-radius-md)',
    backdropFilter: 'blur(var(--modal-blur))',
});

export const BaseContainer = ({ children }: BaseContainerProps) => {
    const { colorScheme } = useMantineColorScheme();

    return (
        <Box p="sm" style={getBaseGlassStyles(colorScheme)}>
            {children}
        </Box>
    );
};
